import Box from "@mui/material/Box";
import ConnectedAccountsPanel from "./ConnectedAccountsPanel";

const ConnectedAccounts = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <ConnectedAccountsPanel />
    </Box>
  );
};

export default ConnectedAccounts;
